// istanbul ignore file
import { type Options, type SeriesAreasplineOptions } from 'highcharts'
import moment from 'moment-timezone'

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export function getFlameSignalDataOptions (
  ModBusParameter1: any = [[null, null, null]],
  unit1 = '',
  registerName1 = '',
  ModBusParameter2: any = [[null, null, null]],
  unit2 = '',
  registerName2 = '',
  ModBusParameter3: any = [[null, null, null]],
  unit3 = '',
  registerName3 = '',
  ModBusParameter4: any = [[null, null, null]],
  unit4 = '',
  registerName4 = ''
): Options {
  const colorMap = ['#9AB7FF', '#FFF55D', '#53CDDB', '#19CB35']

  const seriesData: SeriesAreasplineOptions[] = [
    {
      type: 'areaspline',
      name: registerName1,
      data: ModBusParameter1,
      lineWidth: 4,
      color: colorMap[0], // Use color from the color map
      marker: {
        enabled: true,
        symbol: 'circle',
        radius: 4,
        fillColor: colorMap[0],
        lineColor: '#ffffff',
        lineWidth: 1,
        states: {
          hover: {
            enabled: true
          }
        },
        fillOpacity: 1
      }
    },
    {
      type: 'areaspline',
      name: registerName2,
      data: ModBusParameter2,
      lineWidth: 4,
      color: colorMap[1],
      marker: {
        enabled: true,
        symbol: 'circle',
        radius: 4,
        fillColor: colorMap[1],
        lineColor: colorMap[1],
        lineWidth: 1,
        states: {
          hover: {
            enabled: true
          }
        },
        fillOpacity: 1
      }
    },
    {
      type: 'areaspline',
      name: registerName3,
      data: ModBusParameter3,
      lineWidth: 4,
      color: colorMap[2],
      marker: {
        enabled: true,
        symbol: 'circle',
        radius: 4,
        fillColor: colorMap[2],
        lineColor: colorMap[2],
        lineWidth: 1,
        states: {
          hover: {
            enabled: true
          }
        },
        fillOpacity: 1
      }
    },
    {
      type: 'areaspline',
      name: registerName4,
      data: ModBusParameter4,
      lineWidth: 4,
      color: colorMap[3],
      marker: {
        enabled: true,
        symbol: 'circle',
        radius: 4,
        fillColor: colorMap[3],
        lineColor: colorMap[3],
        lineWidth: 1,
        states: {
          hover: {
            enabled: true
          }
        },
        fillOpacity: 1
      }
    }
  ]

  return {
    chart: {
      height: 280,
      zooming: {
        type: 'xy'
      },
      type: 'areaspline',
      panning: {
        enabled: true,
        type: 'x'
      },
      panKey: 'shift',
      style: {
        fontSize: '16px',
        fontFamily: 'Honeywell Sans Web'
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          menuItems: [
            'downloadJPEG'
          ]
        }
      }
    },
    title: {
      text: ''
    },
    series: seriesData,
    legend: {
      enabled: true,
      itemStyle: {
        fontWeight: '400',
        fontSize: '16px'
      },
      backgroundColor: 'transparent',
      useHTML: true,
      labelFormatter: function () {
        const name = this.name
        const color = colorMap[this.index]
        return `<div style="position: relative;"><span class='icon-class' style="background-color: ${this.visible ? color : '#9AB7FF'}; display: ${(this.name.length > 0) ? 'inline-table' : 'none'}"></span><span class='icon-class-title' style="color: '#f0f0f0'">${name}</span></div>`
      }
    },
    xAxis: {
      title: {
        text: ''
      },
      type: 'datetime',
      labels: {
        formatter: function () {
          return moment(this.value).tz(userTimezone).format('M/D/YYYY hh:mm:ss A')
        }
      },
      minRange: 3600 * 1000 // Minimum range of 1 hour in milliseconds
    },
    yAxis: {
      title: {
        text: ''
      },
      startOnTick: true,
      endOnTick: true
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 2,
          fillOpacity: 1 // Ensures that point colors are displayed accurately
        },
        dataGrouping: {
          enabled: true
          // Adjust based on the data size
        }
      },
      areaspline: {
        fillOpacity: 0,
        states: {
          hover: {
            lineWidth: 2
          }
        },
        marker: {
          enabled: true // Show markers on hover
        }
      }
    },
    tooltip: {
      backgroundColor: '#F0F0F0',
      style: {
        color: 'black',
        fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
        fontSize: '15px',
        fontWeight: '500'
      },
      formatter: function () {
        let unit = '' // Default unit

        // Determine the series and assign the corresponding unit
        switch (this.series.name) {
          case registerName1:
            unit = unit1
            break
          case registerName2:
            unit = unit2
            break
          case registerName3:
            unit = unit3
            break
          case registerName4:
            unit = unit4
            break
          default:
            unit = '' // Default or unknown series
        }
        const newdate = (this.x !== undefined && this.x !== null) ? moment(this.x).tz(userTimezone).format('YYYY-MM-DD hh:mm:ss A') : 'Invalid Date'
        let indexValue = 'Not Available'
        indexValue = (this.y !== undefined && this.y !== null) ? this.y.toString() : 'Not Available'

        return (
          `<span style="background-color:#F0F0F0; color:black; padding:5px; border-radius:5px;">
          <span style="color:black">•&nbsp;&nbsp</span> ${newdate}<br/>•&nbsp;&nbsp;
          ${this.series.name}<br/>•&nbsp;&nbsp;Unit: ${unit}
          <br/>•&nbsp;&nbsp;Value: ${indexValue}
          </span>`
        )
      }
    }
  }
}
